if (!customElements.get("cart-subtotal")) {
  class CartSubtotal extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      if (!event.detail.cartSubtotalHTML) return;

      this.innerHTML = event.detail.cartSubtotalHTML.innerHTML;
    }

    disconnectedCallback() {
      document.removeEventListener("cart:update-html", this.handleUpdateRef);
    }

    connectedCallback() {
      document.addEventListener("cart:update-html", this.handleUpdateRef);
    }
  }

  customElements.define("cart-subtotal", CartSubtotal);
}
